export default __webpack_public_path__ + "static/media/blue-rectangle.2634a52b.svg";